import { Box, Center, ThemeIcon, Title } from '@mantine/core';
import { IconFilesOff } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

export const Empty = (props) => {
    const { t } = useTranslation();

    return (
        <Center>
            <Box style={{ textAlign: 'center'}}>
                <ThemeIcon variant="light" radius="lg" w={48} h={48}>
                    <IconFilesOff />
                </ThemeIcon>
                <Title order={4}>{t('common.noData')}</Title>
            </Box>
        </Center>
    )
}